import React, { useEffect, useState } from 'react';
import ErrorPage from '../../pages/ErrorPage';

const RuntimeErrorHandler = () => {
  const [showError, setShowError] = useState(false);
  const [httpError, setHttpError] = useState(null);

  useEffect(() => {
    const handleHttpError = (event) => {
      const { statusCode, message, error } = event.detail || {};
      
      // Only handle 500 errors here (401 is handled separately)
      if (statusCode === 500) {
        console.log('RuntimeErrorHandler: HTTP 500 error caught', message);
        setHttpError({
          statusCode: 500,
          message: message || 'Internal Server Error',
          error: error
        });
        setShowError(true);
      }
    };

    window.addEventListener('httpError', handleHttpError);

    return () => {
      window.removeEventListener('httpError', handleHttpError);
    };
  }, []);

  const handleClose = () => {
    setShowError(false);
    setHttpError(null);
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <ErrorPage
      error={httpError ? new Error(httpError.message) : null}
      errorInfo={httpError ? { componentStack: httpError.error?.stack || '' } : null}
      errorMessage={httpError?.message || null}
      statusCode={httpError?.statusCode || null}
      isRuntimeError={true}
      show={showError && !!httpError}
      onHide={handleClose}
      onReset={handleReload}
    />
  );
};

export default RuntimeErrorHandler;
